import { render, staticRenderFns } from "./StreamBarcodeReader.vue?vue&type=template&id=0354656d&scoped=true"
import script from "./StreamBarcodeReader.vue?vue&type=script&lang=js"
export * from "./StreamBarcodeReader.vue?vue&type=script&lang=js"
import style0 from "./StreamBarcodeReader.vue?vue&type=style&index=0&id=0354656d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0354656d",
  null
  
)

export default component.exports